import { render, staticRenderFns } from "./bannerItem.vue?vue&type=template&id=1d304913&"
import script from "./bannerItem.vue?vue&type=script&lang=js&"
export * from "./bannerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports